import { FormSection } from '@trellis/roots/forms'
import type { DocumentDiscountType } from '@trellis/shared'
import { Percent } from 'lucide-react'
import { useState } from 'react'

import { DocumentDiscountControl } from './document-discount-control'

export interface DiscountSectionProps {
  /** Whole-document discount, hidden entirely (not just collapsed) when `null`. */
  discount: {
    discountType: DocumentDiscountType
    discount: number
    onChange: (discountType: DocumentDiscountType, discount: number) => void
    exceedsSubtotal: boolean
  } | null
  currency: string
}

export function DiscountSection({ discount, currency }: DiscountSectionProps) {
  const [isDiscountEnabled, setIsDiscountEnabled] = useState(
    discount !== null && (discount.discountType !== 'NONE' || discount.discount > 0),
  )

  if (!discount) return null

  function handleToggle(enabled: boolean) {
    setIsDiscountEnabled(enabled)
    if (!enabled && discount) discount.onChange('NONE', 0)
  }

  return (
    <FormSection
      icon={Percent}
      title="Discount"
      description="Optional whole-document discount."
      toggle={{
        checked: isDiscountEnabled,
        onCheckedChange: handleToggle,
        label: 'Enable',
      }}
    >
      <DocumentDiscountControl
        discountType={discount.discountType}
        discount={discount.discount}
        onChange={discount.onChange}
        currency={currency}
        exceedsSubtotal={discount.exceedsSubtotal}
      />
    </FormSection>
  )
}
